import { CardProject } from "./CardProject";

export function Projects({projects}) {
    return(
        <section className="projects">
            {projects.sort((a, b) => b.orderProject - a.orderProject).map((project, index) => (
                <CardProject
                  key={index}
                  project={project} />
            ))}
        </section>
    );
}